import DashboardLayout from '../layout/DashboardLayout.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import Category from '@/pages/CategoryList.vue'
import Menus from '@/pages/MenusList.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import Login from 'src/pages/Login.vue'

const routes = [
  {
    path: '/',
    redirect: '/overview',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/overview',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'category',
        name: 'Category',
        component: Category,
        meta: {
          requiresAuth: true,
          title: 'All Category'
        }
      },
      {
        path: 'menus',
        name: 'Items',
        component: Menus,
        meta: {
          requiresAuth: true,
          title: 'Menu Items'
        }
      },
      {
        path: 'user/profile',
        name: 'User',
        component: UserProfile,
        meta: {
          requiresAuth: true,
          title: "Your Profile"
        }
      },
      {
        path: 'users/all',
        name: 'All-user',
        component: () => import ('@/pages/UsersList.vue'),
        meta: {
          requiresAuth: true,
          title: "All Users"
        }
      },
      {
        path: 'users/create',
        name: 'Create-user',
        component: () => import ('@/pages/UsersForm.vue'),
        meta: {
          requiresAuth: true,
          title: "Create User"
        }
      },
      {
        path: 'users/edit/:id',
        name: 'edit-user',
        component: () => import ('@/pages/UsersForm.vue'),
        meta: {
          requiresAuth: true,
          title: "Edit User"
        }
      },
      {
        path: 'multiselect/outlet',
        name: 'outlet',
        component: () => import ('@/components/multiselect/Outlets.vue'),
        meta: {
          requiresAuth: true,
          title: 'Outlets Component'
        }
      },
      {
        path: '*',
        name: 'NotFound',
        component: () => import ('@/pages/NotFoundPage.vue'),
        meta: {
          requiresAuth: true,
          title: 'eMenu | Page Not Found!'
        }
      }
    ]
  }
]

export default routes